import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import doc                 from '@widesk-core/decorators/doc';

export default class ExhibitorModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'id':        id;
		'entityUrn': string;
		'eventEdit': boolean;
	};

	static get path(): string {
		return 'exhibitors/{?id}';
	}

	@doc.string declare entityUrn: string;
	@doc.boolean declare eventEdit: boolean;
}
